import { render, staticRenderFns } from "./smallPrint.vue?vue&type=template&id=d8c3d800&scoped=true&"
import script from "./smallPrint.vue?vue&type=script&lang=js&"
export * from "./smallPrint.vue?vue&type=script&lang=js&"
import style0 from "./smallPrint.vue?vue&type=style&index=0&id=d8c3d800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c3d800",
  null
  
)

export default component.exports